module.exports = __webpack_public_path__ + "img/users_menu3.c4e741fa.png";